const user = require('./user');
export const actions = {
    ...user
};
